import { CircularProgress, ButtonProps, SxProps, Theme } from "@mui/material";
import { FC } from "react";
import { Colors } from "../../../configs";
import { CustomButton } from "../button/button";

export interface PosButtonProps extends ButtonProps {
    loading?: boolean;
    variantType?: "primary" | "secondary";
}

export const PosButton: FC<PosButtonProps> = ({
    children,
    loading,
    variantType = "primary",
    sx,
    ...props
}) => {
    const isPrimary = variantType === "primary";

    const primaryStyles: SxProps<Theme> = {
        width: "100%",
        height: "5.857142857142857rem",
        fontSize: "2.28rem",
        borderRadius: "0.71rem",
        background: Colors.PRIMARY,
        color: Colors.WHITE,
        textTransform: "capitalize",
        flexGrow: 1,
        "&:hover": { background: `${Colors.PRIMARY} !important` },
    };

    const secondaryStyles: SxProps<Theme> = {
        background: Colors.MAIN_GRAY,
        color: Colors.WHITE,
        fontSize: "1.42rem",
        borderRadius: "0.71rem",
        textTransform: "capitalize",
        height: "3.714285714285714rem",
        "&:hover": { background: `${Colors.MAIN_GRAY} !important` },
    };

    return (
        <CustomButton
            sx={{
                ...(isPrimary ? primaryStyles : secondaryStyles),
                ...sx,
            }}
            disabled={props.disabled || loading}
            {...props}
        >
            {loading ? (
                <CircularProgress sx={{ color: Colors.WHITE }} />
            ) : (
                children
            )}
        </CustomButton>
    );
};
